module.exports = __webpack_public_path__ + "media/assets/images/title_window-75180b143cab17545b0f509489da5233.png";